import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { Gallery } from "@/components/gallery/gallery";
import { apartmentLocationProjectGalleryData } from './apartment-location-project-gallery.data';
import { ImageResourceDTO } from '../../../model/ImageResourceDTO';

@Block(apartmentLocationProjectGalleryData)
@Component({
	components: {
		Gallery
	}
})
export class ApartmentLocationProjectGalleryBlock extends BaseBlock {
	@Prop() gallery: ImageResourceDTO[][];
}

export default ApartmentLocationProjectGalleryBlock;
